// hooks/useCameraInstallationData.ts
import { getCameraInstallationAnalytics } from '@api/services/analytics.service';
import useDataQuery from '@hooks/use-data-query';

const useCameraInstallationData = (startDate: string, endDate: string) => {
    // const [search, setSearch] = useState('');

    // const changeSearch = useCallback((val: string) => {
    //     setSearch(val);
    // }, []);

    const query = useDataQuery(['camera-installations', 'analytics', startDate, endDate], () =>
        getCameraInstallationAnalytics(startDate, endDate)
    );

    const allData = query.data || [];

    // const filteredData = useMemo(() => {
    //     if (!search) return allData;
    //     return allData.filter(
    //         (item: ICameraInstallationAnalytics) =>
    //             item.name?.toLowerCase().includes(search.toLowerCase()) ||
    //             item.client?.name?.toLowerCase().includes(search.toLowerCase()) ||
    //             item.project?.name?.toLowerCase().includes(search.toLowerCase())
    //     );
    // }, [allData, search]);

    return {
        data: allData,
        isLoading: query.isLoading,
    };
};

export default useCameraInstallationData;
